import { Component } from '@angular/core';

@Component({
  selector: 'app-blank-layout',
  template: `
    <div>
      <router-outlet></router-outlet>
    </div>
  `,
  styles: []
})


export class BlankLayoutComponent {

}
